import React from "react";
import { Button, Grid2 as Grid, Grid2Props } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import FormLabel from "../../../../components/forms/common/base/FormLabel";
import { useFormHandlerContext } from "../../../../controllers/formController";
import ArraySubFormList from "../../../../components/forms/fields/subForms/array/ArraySubFormList";
import ArraySubFormProvider from "../../../../components/forms/fields/subForms/array/ArraySubFormProvider";
import ArraySubFormAdd from "../../../../components/forms/fields/subForms/array/ArraySubFormAdd";
import { singleGridItem } from "../../../../components/forms/fields/defaultStyles";
import TitleEvidenceItem from "./TitleEvidenceItem";

interface TitleEvidenceProps extends Grid2Props {
  name: string;
  label: string;
  rowLabel: string;
  disabled?: boolean;
}

const TitleEvidence: React.FC<TitleEvidenceProps> = ({
  name,
  label,
  rowLabel,
  disabled = false,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();

  return (
    <Grid container spacing={1} {...singleGridItem} {...grid}>
      <FormLabel label={label} name={name} />
      <ArraySubFormProvider name={name}>
        <ArraySubFormList
          renderItem={(index, remove) => (
            <TitleEvidenceItem
              evidenceTypeFieldName="evidence_type"
              evidenceSubTypeFieldName="evidence_subtype"
              label={`${rowLabel} ${index + 1}`}
              disabled={disabled || isProcessing}
              remove={remove}
            />
          )}
        />

        <Grid {...singleGridItem}>
          <ArraySubFormAdd
            render={(append) => (
              <Button
                variant="contained"
                fullWidth
                color="primary"
                startIcon={<AddCircleOutline />}
                onClick={() =>
                  append({
                    evidence_type: null,
                    evidence_subtype: null,
                    metadata: [],
                  })
                }
                disabled={isProcessing}
              >
                Add {rowLabel}
              </Button>
            )}
          />
        </Grid>
      </ArraySubFormProvider>
    </Grid>
  );
};
export default TitleEvidence;
